var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarDayGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_337_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.03143 0.437012C4.5889 0.437012 5.03929 0.887398 5.03929 1.44487V2.45273H9.07071V1.44487C9.07071 0.887398 9.5211 0.437012 10.0786 0.437012C10.636 0.437012 11.0864 0.887398 11.0864 1.44487V2.45273H12.5982C13.4328 2.45273 14.11 3.12988 14.11 3.96451V5.4763H0V3.96451C0 3.12988 0.677154 2.45273 1.51179 2.45273H3.02357V1.44487C3.02357 0.887398 3.47396 0.437012 4.03143 0.437012ZM0 6.48416H14.11V15.0509C14.11 15.8856 13.4328 16.5627 12.5982 16.5627H1.51179C0.677154 16.5627 0 15.8856 0 15.0509V6.48416ZM2.51964 8.49987C2.24248 8.49987 2.01571 8.72664 2.01571 9.0038V12.0274C2.01571 12.3045 2.24248 12.5313 2.51964 12.5313H5.54321C5.82037 12.5313 6.04714 12.3045 6.04714 12.0274V9.0038C6.04714 8.72664 5.82037 8.49987 5.54321 8.49987H2.51964Z",
    fill: "#B2B3B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_337_1261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.11,
    height: 16.1257,
    fill: "white",
    transform: "translate(0 0.437012)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDayGray);
export default __webpack_public_path__ + "static/media/calendar-day-gray.4b8091e2bcc9f53f214376ad6afe2770.svg";
export { ForwardRef as ReactComponent };